import { cn } from "@shared/lib";

export interface MembersEmptyStateProps {
  title: string;
  body: string;
  className?: string;
}

export function MembersEmptyState({
  title,
  body,
  className,
}: MembersEmptyStateProps) {
  return (
    <div
      role="status"
      className={cn(
        "flex flex-col items-center gap-3 rounded-lg border border-dashed bg-background p-8 text-center",
        className,
      )}
    >
      <h2 className="text-base font-semibold">{title}</h2>
      <p className="max-w-sm text-sm text-muted-foreground">{body}</p>
    </div>
  );
}
